// ABOUTME: Context and hook for the AI Chat widget open/closed state
// ABOUTME: The provider lives in ChatProvider.tsx; this file has no components so Fast Refresh keeps state

import { createContext, useContext } from "react"

export interface ChatContextType {
  isOpen: boolean
  openChat: () => void
  closeChat: () => void
  toggleChat: () => void
}

export const ChatContext = createContext<ChatContextType | null>(null)

export const useChatContext = () => {
  const context = useContext(ChatContext)
  if (!context) {
    throw new Error("useChatContext must be used within a ChatProvider")
  }
  return context
}
